/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_NumberInputs */

const en_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event number`)
};

const fr_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro d’événement`)
};

const de_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisnummer`)
};

const it_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero dell'evento`)
};

const ru_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Номер события`)
};

const es_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de evento`)
};

const zh_cn2_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件编号`)
};

const ja_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント番号`)
};

const hi_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना संख्या`)
};

const pt_pt2_event_number = /** @type {(inputs: Event_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número do evento`)
};

/**
* | output |
* | --- |
* | "Event number" |
*
* @param {Event_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_number = /** @type {((inputs?: Event_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_number(inputs)
	if (locale === "de") return de_event_number(inputs)
	if (locale === "it") return it_event_number(inputs)
	if (locale === "ru") return ru_event_number(inputs)
	if (locale === "es") return es_event_number(inputs)
	if (locale === "zh-CN") return zh_cn2_event_number(inputs)
	if (locale === "ja") return ja_event_number(inputs)
	if (locale === "hi") return hi_event_number(inputs)
	if (locale === "pt-PT") return pt_pt2_event_number(inputs)
	return en_event_number(inputs)
});